<ng-container *ngIf="this.jsonControl ">
    <json-editor [options]="this.editorOptions" [formControl]="jsonControl"
        style="height:77vh;" class="block"></json-editor>

    <section class="tw-flex tw-basis-full tw-p-2 tw-mt-2 tw-justify-end tw-space-x-2">
        <button pButton (click)="this.reset($event)" icon="fal fa-rotate-left" label="Reset"
            class="p-button-outlined p-button-warning"></button>
        <button pButton (click)="this.save($event)" icon="fal fa-save" label="Save"></button>
    </section>
</ng-container>
